import React, {FC} from 'react';

import {styled, useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface BannerTimeRemainingProps {
  /** How long it should take for the progress bar to go from 0 to 100%, in milliseconds. */
  duration: number;
}

/*
 * Style.
 */

const StyledProgressDiv = styled.div<{duration: number}>`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;

  @keyframes slideIn {
    0% {
      transform: translateX(0);
    }

    100% {
      transform: translateX(100%);
    }
  }

  animation: ${(p) => p.duration}ms slideIn linear forwards;
`;

/*
 * Component.
 */

export const BannerTimeRemaining: FC<BannerTimeRemainingProps> = (props) => {
  const theme = useUserTheme();
  return <StyledProgressDiv duration={props.duration} style={{backgroundColor: theme.bannerTimeRemaining}} />;
};
